import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Card } from './ui/Card';
import { Reveal } from './ui/Reveal';
const metrics = [{
  value: '$42B+',
  label: 'Operations',
  detail: 'Annual operations leadership'
}, {
  value: '$18B+',
  label: 'Acquisitions',
  detail: 'Portfolio oversight'
}, {
  value: '$10B',
  label: 'Energy',
  detail: 'Energy portfolio managed'
}, {
  value: '27,000',
  label: 'Personnel',
  detail: 'Enterprise leadership'
}, {
  value: '$523M',
  label: 'Savings',
  detail: 'Projected cost reductions'
}, {
  value: '110',
  label: 'Units',
  detail: 'Ebola treatment units in 10 days'
}, {
  value: '$1.5M',
  label: 'Growth',
  detail: 'Consulting revenue growth'
}];
export function MetricsSection() {
  return <Section id="metrics" variant="navy" data-id="element-267">
      <SectionHeader title="Impact Metrics" subtitle="Key Accomplishments" data-id="element-268" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-269">
        {metrics.map((metric, index) => <Reveal key={index} delay={index * 100} data-id="element-270">
            <Card className="text-center h-full flex flex-col justify-center py-10" data-id="element-271">
              <span className="text-4xl md:text-5xl font-bold text-gold-500 mb-2 font-heading tracking-tight" data-id="element-272">
                {metric.value}
              </span>
              <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-4 border-b border-white/10 pb-4 mx-8" data-id="element-273">
                {metric.label}
              </h4>
              <p className="text-slate-400 text-sm px-4" data-id="element-274">{metric.detail}</p>
            </Card>
          </Reveal>)}
      </div>
    </Section>;
}